import { selectUser } from "./selectUser";

export const selectIsLoading = (state) => selectUser(state).isFetching;
